import { Menu } from '@chakra-ui/react';
import { useLingui } from '@lingui/react/macro';

import { useAuth } from '#modules/user/features/auth/hooks/useAuth';
import { useProfile } from '#modules/user/features/profile/hooks/useProfile';
import { Link } from '#features/routing';
import { Avatar } from '#features/ui/components/Avatar';
import { IconButton } from '#features/ui/components/IconButton';
import { MenuContent } from '#features/ui/components/Menu';
import { useGuardedLink } from '../../hooks/useGuardedLink';

export const UserSettings = () => {
  const { profile } = useProfile();
  const { logout } = useAuth();

  const { t } = useLingui();
  const guardLink = useGuardedLink();

  const onLogoutClick = async () => {
    logout();
  };

  return (
    <Menu.Root positioning={{ strategy: 'fixed', offset: { mainAxis: 20 } }}>
      <Menu.Trigger asChild>
        <IconButton
          variant="ghost"
          aria-label={t`Account menu`}
          minW="44px"
          minH="44px"
          borderRadius="full"
          position="relative"
        >
          <Avatar size="sm" src={profile?.avatar} name={profile?.displayName ?? undefined} />
        </IconButton>
      </Menu.Trigger>
      <MenuContent>
        {/*
          «Друзья» отсюда ушли в навигацию - нижнюю панель телефона и левое меню десктопа, а
          вместе с ними и сигнал новых подписчиков: точка на аватаре звала в пункт, которого
          здесь больше нет. Настройки переехали сюда из нижней панели телефона. Обратной связи в
          меню нет - в шапке рядом с колокольчиком у неё своя иконка.
        */}
        <Menu.ItemGroup>
          <Menu.Item value="profile" asChild>
            <Link to="/{-$locale}/dashboard/profile" onClick={guardLink}>{t`My profile`}</Link>
          </Menu.Item>
          <Menu.Item value="settings" asChild>
            <Link
              to="/{-$locale}/dashboard/settings"
              onClick={guardLink}
            >{t`dashboard:settings.title`}</Link>
          </Menu.Item>
        </Menu.ItemGroup>
        <Menu.Separator />
        <Menu.Item onClick={onLogoutClick} value="logout">
          {t`common:auth.logOut`}
        </Menu.Item>
      </MenuContent>
    </Menu.Root>
  );
};
